import api from "./api";

/**
 * 获取封面图片 URL
 * @param {string} pageType - 页面类型 ('register' 或 'thanks')
 * @returns {Promise<{image_url: string | null}>}
 */
export async function getCoverImage(pageType) {
	try {
		const response = await api.get(`/member-center/cover-image/${pageType}`);
		return response.data || { image_url: null };
	} catch (error) {
		console.error("Failed to fetch cover image:", error);
		// 如果 API 失败，返回 null，使用默认图片
		return { image_url: null };
	}
}
